import { useSession } from '@common/contexts/session';

export const useIsTexas = () => {
  const { currentUser } = useSession();
  return currentUser.organizationState === 'Texas';
};
